window.initSelectize = (obj: JQuery<HTMLElement>) => {
  obj.selectize({
    sortField: 'text',
  });
};
